import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { DynamicFormatPipe } from 'src/app/pipes/formats/dynamic-format.pipe';

@Component({
  selector: 'app-custom-table-print',
  templateUrl: './custom-table-print.component.html',
  styleUrls: ['./custom-table-print.component.scss'],
  standalone: true,
  imports: [TableModule, CommonModule, DynamicFormatPipe]
})
export class CustomTablePrintComponent {
  @Input() columns: { field: string; header: string; }[] = [];
  // @Input() idMap: { [key: string]: { id: string; type: string; showTotal: boolean; } } = {};
  @Input() idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat?: string | null; } } = {};
  @Input() data: any[] = [];
  @Input() documentId: number = 0;
  @Input() editFormat: boolean = false;
  @Input() footerVisible: boolean = false;

  @Output() newIndexColumns = new EventEmitter<{ field: string; header: string; }[]>();
  @Output() clickTableEvent = new EventEmitter();
  constructor() { }

  onColumnReorder() {
    this.newIndexColumns.emit(this.columns);
  }

  clickTable(event: any) {
    this.clickTableEvent.emit(event);
  }

  getTotal(field: string): number {
    if (!this.data || this.data.length === 0) return 0;

    return this.data.reduce((sum, row) => {
      const value = row[field];
      return sum + (typeof value === 'number' ? value : 0);
    }, 0);
  }

}
